module.exports = __webpack_public_path__ + "static/media/tools_data_image.7bdef488.png";